<template>
  <div class="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-950/20 dark:to-orange-950/20">
    <div class="w-full max-w-md text-center bg-white dark:bg-gray-900 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700">
      <!-- Header -->
      <div class="pb-4 px-6 pt-6">
        <div class="mx-auto mb-4 w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
          <XCircle class="w-8 h-8 text-red-600 dark:text-red-400" />
        </div>
        <h2 class="text-2xl font-bold text-red-700 dark:text-red-300">
          Payment Cancelled
        </h2>
        <p class="text-base text-gray-600 dark:text-gray-400">
          Your payment was cancelled. No charges were made to your account.
        </p>
      </div>

      <!-- Content -->
      <div class="px-6 pb-6 space-y-4">
        <div class="p-4 bg-orange-50 dark:bg-orange-900/20 rounded-lg">
          <p class="text-sm text-orange-700 dark:text-orange-300">
            If you experienced any issues during checkout, please try again or contact support.
          </p>
        </div>
        <div class="flex flex-col sm:flex-row gap-3">
          <button
            @click="goDashboard"
            class="flex-1 inline-flex items-center justify-center px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800 transition"
          >
            <ArrowLeft class="w-4 h-4 mr-2" />
            Back to Dashboard
          </button>
          <button
            @click="tryAgain"
            class="flex-1 inline-flex items-center justify-center px-4 py-3 rounded-lg bg-red-600 text-white hover:bg-red-700 transition font-medium"
          >
            <RefreshCw class="w-4 h-4 mr-2" />
            Try Again
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-vue-next';

export default {
  name: 'PaymentCancel',
  components: { XCircle, ArrowLeft, RefreshCw },
  methods: {
    goDashboard() {
      this.$router.push('/crm');
    },
    tryAgain() {
      this.$router.push('/settings');
    },
  },
};
</script>
